import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const addGroupWithHeader = (
  companyName: string,
  creatorUid: string,
  signupHeader: Record<string, string> | null,
  firstName: string,
  lastName: string,
  email: string,
) => {
  const espacedName = encodeURIComponent(companyName);
  if (signupHeader) {
    const addGroupInit = {
      headers: signupHeader,
      body: `groupname=${espacedName}&uid=${creatorUid}&firstname=${firstName}&lastname=${lastName}&email=${email}`,
    };
    return apiPost('/group/register', addGroupInit);
  } else {
    const {
      project: { header },
    } = store.getState();
    const addGroupInit = {
      headers: header,
      body: `groupname=${espacedName}&uid=${creatorUid}&firstname=${firstName}&lastname=${lastName}&email=${email}`,
    };
    return apiPost('/group/register', addGroupInit);
  }
};

export const addGroup = (companyName: string, creatorUid: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const espacedName = encodeURIComponent(companyName);
  const addGroupInit = {
    headers: header,
    body: `groupname=${espacedName}&uid=${creatorUid}&parent=${currentUserGroup}`,
  };
  return apiPost(`/group/add?gid=${currentUserGroup}`, addGroupInit);
};

export const addGroupWithImage = (companyName: string, creatorUid: string, storageKey: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();

  const imageS3Path = `private/${identityId}/${storageKey}`;
  const espacedName = encodeURIComponent(companyName);
  const addGroupInit = {
    headers: header,
    body: `groupname=${espacedName}&uid=${creatorUid}&image=${imageS3Path}&parent=${currentUserGroup}`,
  };

  return apiPost(`/group/add?gid=${currentUserGroup}`, addGroupInit);
};

export const updateWorkspaceImage = (groupId: string | { S: string }, storageResponseKey: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const resourceS3Path = `private/${identityId}/${storageResponseKey}`;
  const updateWorkspaceImageInit = {
    headers: header,
    body: `image=${resourceS3Path}`,
  };
  const gid = typeof groupId === 'string' ? groupId : groupId.S;
  return apiPost(`/group/update?gid=${gid}`, updateWorkspaceImageInit);
};

export const removeWorkspaceImage = (groupId: string | { S: string }) => {
  const {
    project: { header },
  } = store.getState();
  const updateWorkspaceImageInit = {
    headers: header,
    body: 'image=no-image',
  };
  const gid = typeof groupId === 'string' ? groupId : groupId.S;
  return apiPost(`/group/update?gid=${gid}`, updateWorkspaceImageInit);
};

export const updateWorkspaceName = (groupId: string | { S: string }, name: string) => {
  const {
    project: { header },
  } = store.getState();

  const espacedName = encodeURIComponent(name);

  const updateWorkspaceNameInit = {
    headers: header,
    body: `groupname=${espacedName}`,
  };
  const gid = typeof groupId === 'string' ? groupId : groupId.S;
  return apiPost(`/group/update?gid=${gid}`, updateWorkspaceNameInit);
};

export const getRootWorkspaceDetails = () => {
  const {
    project: { header },
    workspace: { rootGroup },
  } = store.getState();
  const getRootWorkspaceSizeInit = {
    headers: header,
  };
  return apiGet(
    `/group/usage?gid=${rootGroup?.id}`,
    getRootWorkspaceSizeInit,
  );
};

export const subscripePlan = (gid: string, plan: string) => {
  const {
    project: { header },
  } = store.getState();
  const getRootWorkspaceSizeInit = {
    headers: header,
  };
  return apiGet(
    `/stripe/get-session?gid=${gid}&plan=${plan}`,
    getRootWorkspaceSizeInit,
  );
};

export const deleteWorkspace = (groupId: string | { S: string }) => {
  const {
    project: { header },
  } = store.getState();
  const id = typeof groupId === 'string' ? groupId : groupId.S;
  const updateWorkspaceImageInit = {
    headers: header,
    body: `id=${id}`,
  };

  return apiPost(`/group/delete?id=${id}`, updateWorkspaceImageInit);
};
